var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTestTube = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "transparent",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.0001 4.66927L4.54681 14.1226C4.19245 14.4731 3.71382 14.6691 3.21544 14.6678C2.71706 14.6666 2.23941 14.4682 1.88681 14.1159C1.53345 13.7622 1.33496 13.2826 1.33496 12.7826C1.33496 12.2826 1.53345 11.803 1.88681 11.4493L11.3335 2.0026M10.6668 1.33594L14.6668 5.33594M8.00015 10.6693H2.66681",
  stroke: "currentcolor",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTestTube);
export default ForwardRef;